import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState,  BaasicButton } from 'core/components';
import { PreviewLayout, PageFooter } from 'core/layouts';
import { toDate } from 'core/utils';

function TemplatePreviewTemplate({ templatePreviewViewStore, t }) {
    const {
        rootStore,
        item,
        loaderStore,
        brightreeBaseUrl
    } = templatePreviewViewStore;

    const payors = item ? item.salesOrderInsuranceInfo.payors.map(item =>
        <div className="row" key={item.brightreeId}>
                        <div className="form__group col col-sml-12 col-lrg-3">
                            <div className="form__group__label is-preview">{t('Name')}</div>                            
                                <span>
                                    {item && item.payorPolicyInfo && <React.Fragment>{item.payorPolicyInfo.name }</React.Fragment>}
                                </span>
                            </div>
                            <div className="form__group col col-sml-12 col-lrg-2">
                            <div className="form__group__label is-preview">{t('Include Box 24Jb')}</div>                            
                                <span>
                                    {item && <React.Fragment>{item.includeBox24Jb ? 
                                        <i className="u-icon u-icon--sml u-icon--active"></i> : 
                                        <i className="u-icon u-icon--sml u-icon--inactive"></i>}</React.Fragment>}
                                </span>
                            </div>
                            <div className="form__group col col-sml-12 col-lrg-2">
                                <div className="form__group__label is-preview">{t('Include on Sales Order')}</div>                            
                                <span>
                                    {item && <React.Fragment>{item.includeOnSO ? 
                                        <i className="u-icon u-icon--sml u-icon--active"></i> : 
                                        <i className="u-icon u-icon--sml u-icon--inactive"></i>}</React.Fragment>}
                                </span>
                            </div>
                            <div className="form__group col col-sml-12 col-lrg-3">
                                <div className="form__group__label is-preview">{t('Wait for previous before billing')}</div>                            
                                <span>
                                    {item && <React.Fragment>{item.waitForPreviousPayorForBilling ? 
                                        <i className="u-icon u-icon--sml u-icon--active"></i> : 
                                        <i className="u-icon u-icon--sml u-icon--inactive"></i>}</React.Fragment>}
                                </span>
                            </div>
                            <div className="form__group col col-sml-12 col-lrg-2">
                                <div className="form__group__label is-preview">{t('Pay Pct equal to 0%')}</div>                            
                                <span>
                                    {item && <React.Fragment>{item.payPercentEqualToZero ? 
                                        <i className="u-icon u-icon--sml u-icon--active"></i> : 
                                        <i className="u-icon u-icon--sml u-icon--inactive"></i>}</React.Fragment>}
                                </span>
                            </div>
                        </div>
    ) : [];

    const salesOrderTemplateItems = item ? item.salesOrderTemplateItems.map(item =>
        <div className="row" key={item.brightreeDetailID}>
            <div className="form__group col col-sml-12 col-lrg-3">
                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.ITEM_ID')}</div>
                <span>
                    <React.Fragment>{item.itemId}</React.Fragment>
                </span>
            </div>
            <div className="form__group col col-sml-12 col-lrg-3">
                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.ITEM_NAME')}</div>
                <span>
                    <React.Fragment>{item.itemName}</React.Fragment>
                </span>
            </div>
            <div className="form__group col col-sml-12 col-lrg-2">
                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.PROCEDURE_CODE')}</div>
                <span>
                    <React.Fragment>{item.procCode}</React.Fragment>
                </span>
            </div>
            <div className="form__group col col-sml-12 col-lrg-2">
                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.QUANTITY')}</div>
                <span>
                    <React.Fragment>{item.quantity}</React.Fragment>
                </span>
            </div>
            <div className="form__group col col-sml-12 col-lrg-2">
                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.BILL_QUANTITY')}</div>
                <span>
                    <React.Fragment>{item.billQuantity}</React.Fragment>
                </span>
            </div>
        </div>
        ) : [];

    return (
        <PreviewLayout store={templatePreviewViewStore} emptyRenderer={<ApplicationEmptyState />} loading={loaderStore.loading}>
            <div className="card card--form card--primary card--med">
            <div className="card__header u-mar--bottom--med">
                    {item ? <a target='_blank' href={brightreeBaseUrl + 'OrderEntry/frmSOOrderRO.aspx?SalesOrderTemplateKey='+item.brightreeId+'&ShowAck=0&Edit=0'}>
                        <BaasicButton className='btn btn--base btn--ghost u-mar--left--auto' label={'Template link'}/></a> : null}
                    </div>
                <div className="row">
                    <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                        <h4 className="form__title form__title--preview">Template</h4>
                        <div className="row">
                            <div className="form__group col col-sml-12 col-lrg-3">
                                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.BRANCH_NAME')}</div>                            
                                <span>
                                    {item && <React.Fragment>{item.salesOrderTemplateGeneralInfo.branch}</React.Fragment>}
                                </span>
                            </div>
                            <div className="form__group col col-sml-12 col-lrg-3">
                                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.TEMPLATE_NAME')}</div>                            
                                <span>
                                    {item && <React.Fragment>{item.templateName}</React.Fragment>}
                                </span>
                            </div>
                            <div className="form__group col col-sml-12 col-lrg-3">
                                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.REFERENCE')}</div>                            
                                <span>
                                    {item && <React.Fragment>{item.salesOrderTemplateGeneralInfo.reference}</React.Fragment>}
                                </span>
                            </div>
                            <div className="form__group col col-sml-12 col-lrg-3">
                                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.ORDER_NOTE')}</div>                            
                                <span>
                                    {item && <React.Fragment>{item.salesOrderTemplateDeliveryInfo.orderNote ? item.salesOrderTemplateDeliveryInfo.orderNote : 'N/A'}</React.Fragment>}
                                </span>
                        </div>
                        </div>
                        <div className="row">
                        <div className="form__group col col-sml-12 col-lrg-3">
                                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.START_DATE')}</div>                            
                                <span>
                                    {item && <React.Fragment>{toDate(item.salesOrderTemplateSchedule.startDate)}</React.Fragment>}
                                </span>
                            </div>
                        <div className="form__group col col-sml-12 col-lrg-3">
                                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.NEXT_RUN_DATE')}</div>                            
                                <span>
                                    {item && <React.Fragment>{toDate(item.nextRunDate)}</React.Fragment>}
                                </span>
                            </div>
                        <div className="form__group col col-sml-12 col-lrg-3">
                                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.WEEK')}</div>                            
                                <span>
                                    {item && <React.Fragment>{item.salesOrderTemplateSchedule.timeInterval}</React.Fragment>}
                                </span>
                            </div>
                        <div className="form__group col col-sml-12 col-lrg-3">
                                <div className="form__group__label is-preview">{t('TEMPLATES.PREVIEW.DAY')}</div>                            
                                <span>
                                    {item && <React.Fragment>{item.salesOrderTemplateSchedule.weekDayFlags}</React.Fragment>}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                    <h4 className="form__title form__title--preview">Insurance</h4>
                    {payors}
                    </div>
                    <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                        <h4 className="form__title form__title--preview">Items</h4>
                        {salesOrderTemplateItems}
                    </div>
                </div>
            </div>
            <PageFooter>
                <BaasicButton
                    className='btn btn--base btn--ghost'
                    label={('LIST_LAYOUT.BACK_BUTTON')}
                    onClick={() => rootStore.routerStore.goBack()}
                    icon='u-icon u-icon--xsml u-icon--btn-back'
                />
            </PageFooter>
        </PreviewLayout>
    )
}

TemplatePreviewTemplate.propTypes = {
    templatePreviewViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(TemplatePreviewTemplate);
